/* STICKYHUGO CUSTOM: Add the existing _KI badge to images inside blog article content. */
(function () {
  const AI_IMAGE_PATTERN = /_ki(?:[_.-]|$)/i;
  const BADGE_TITLE =
    'Dieses Produktbild wurde mithilfe künstlicher Intelligenz generiert oder bearbeitet.';

  function hasAiMarker(image) {
    const sources = [
      image.currentSrc,
      image.getAttribute('src'),
      image.getAttribute('srcset'),
      image.getAttribute('data-src'),
      image.getAttribute('data-srcset'),
    ];

    return sources.some(function (source) {
      if (!source) return false;

      try {
        source = decodeURIComponent(source);
      } catch (error) {
        // Keep the original URL if it contains an invalid escape sequence.
      }

      return AI_IMAGE_PATTERN.test(source);
    });
  }

  function addBadge(image) {
    if (!hasAiMarker(image)) return;

    const picture = image.closest('picture');
    const imageElement = picture || image;
    const currentWrapper = imageElement.parentElement;

    if (
      currentWrapper &&
      currentWrapper.classList.contains('ai-image-container--article-content')
    ) {
      return;
    }

    const wrapper = document.createElement('span');
    wrapper.className =
      'ai-image-container ai-image-container--article-content';

    imageElement.parentNode.insertBefore(wrapper, imageElement);
    wrapper.appendChild(imageElement);

    const badge = document.createElement('span');
    badge.className = 'ai-image-badge';
    badge.title = BADGE_TITLE;
    badge.setAttribute('aria-label', BADGE_TITLE);
    badge.textContent = 'MIT KI ERSTELLT';
    wrapper.appendChild(badge);
  }

  function initializeArticleBadges(scope) {
    const container = scope || document;

    container
      .querySelectorAll('.article-template__content img')
      .forEach(addBadge);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeArticleBadges(document);
    });
  } else {
    initializeArticleBadges(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeArticleBadges(event.target);
  });
})();
